import { useState } from "react";
import { Alan } from "./Alan";
import { Buton } from "./Buton";
import { OnayKutusu } from "./OnayKutusu";
import { SifreGucu, type GucSeviyesi } from "./SifreGucu";

export interface SifreDegistirVerisi {
  mevcutSifre: string;
  yeniSifre: string;
  digerOturumlariSonlandir: boolean;
}

export interface SifreDegistirFormuProps {
  /** Güç çubuğu — hesap türünün asgarisiyle (contracts `sifreGucu`). Politika SUNUCUDA. */
  gucHesapla: (sifre: string) => GucSeviyesi;
  gucAdi: Record<GucSeviyesi, string>;
  /** Hesap türünün asgari uzunluğu — yalnız yardım metni için. */
  enAz: number;
  gonderiliyor: boolean;
  /** Sunucunun genel hata metni (yanlış mevcut şifre, deneme sınırı…). */
  hata: string | null;
  /** Yeni şifrenin politika ayrıntısı (`ayrinti.yeniSifre`). */
  yeniSifreHatasi?: string | null;
  basari: string | null;
  onGonder: (v: SifreDegistirVerisi) => void;
}

/**
 * ŞİFRE DEĞİŞTİRME FORMU — G-AUT-08a (A9, 05.10.2026)
 *
 * SUNUM BİLEŞENİ: API bilmez, kararı vermez. Panel ve öğrenci/veli
 * uygulaması AYNI formu kullanıyor; iki kopya ayrı ayrı yazılsaydı biri
 * "diğer oturumları kapat" seçeneğini unutur ya da varsayılanını ters
 * koyardı.
 *
 * Formun kendi kontrolü yalnız sunucuya gitmeden anlaşılabilecek şey:
 * alanlar boş mu, yeni şifre iki kez aynı yazılmış mı. Uzunluk, yaygın ve
 * sızmış şifre kararı sunucuda (`SifreService.politikaliOzet`).
 *
 * "Diğer cihazlardaki oturumları kapat" VARSAYILAN AÇIK: şifre değiştiren
 * kişi çoğu zaman "biri hesabıma girmiş olabilir" diye değiştiriyor.
 */
export function SifreDegistirFormu({
  gucHesapla,
  gucAdi,
  enAz,
  gonderiliyor,
  hata,
  yeniSifreHatasi,
  basari,
  onGonder,
}: SifreDegistirFormuProps) {
  const [mevcut, setMevcut] = useState("");
  const [yeni, setYeni] = useState("");
  const [tekrar, setTekrar] = useState("");
  const [digerleri, setDigerleri] = useState(true);
  const [denendi, setDenendi] = useState(false);

  const tekrarHatasi =
    denendi && tekrar.length > 0 && tekrar !== yeni ? "İki şifre aynı değil." : undefined;
  const eksik = mevcut.length === 0 || yeni.length === 0 || tekrar.length === 0;
  const guc = gucHesapla(yeni);

  return (
    <form
      className="flex flex-col gap-3"
      onSubmit={(e) => {
        e.preventDefault();
        setDenendi(true);
        if (eksik || tekrar !== yeni) return;
        onGonder({ mevcutSifre: mevcut, yeniSifre: yeni, digerOturumlariSonlandir: digerleri });
      }}
    >
      <Alan
        etiket="Mevcut şifre"
        type="password"
        autoComplete="current-password"
        value={mevcut}
        onChange={(e) => setMevcut(e.target.value)}
      />
      <Alan
        etiket="Yeni şifre"
        type="password"
        autoComplete="new-password"
        value={yeni}
        onChange={(e) => setYeni(e.target.value)}
        hata={yeniSifreHatasi ?? undefined}
        yardim={`En az ${enAz} karakter. Yaygın ve sızmış şifreler kabul edilmez.`}
      />
      {yeni.length > 0 && <SifreGucu seviye={guc} ad={gucAdi[guc]} />}
      <Alan
        etiket="Yeni şifre (tekrar)"
        type="password"
        autoComplete="new-password"
        value={tekrar}
        onChange={(e) => setTekrar(e.target.value)}
        hata={tekrarHatasi}
      />
      <OnayKutusu
        etiket="Diğer cihazlardaki oturumlarımı kapat"
        yardim="Bu cihazdaki oturumunuz açık kalır. Kayıtlı güvenilir cihazlar her durumda kaldırılır."
        checked={digerleri}
        onChange={(e) => setDigerleri(e.target.checked)}
      />

      {hata && (
        <p role="alert" className="text-hata-700 text-sm font-medium">
          {hata}
        </p>
      )}
      {basari && (
        <p role="status" className="text-onay-700 text-sm font-medium">
          {basari}
        </p>
      )}

      <div>
        <Buton type="submit" yukleniyor={gonderiliyor} disabled={eksik}>
          Şifreyi değiştir
        </Buton>
      </div>
    </form>
  );
}
